import { capitalize } from "../../../components/helpers/capitalize";

export const convertCategory = (categories) => {
  let convertedCategories = [];

  categories.forEach((category) => {
    convertedCategories.push({
      value: category.id,
      label: capitalize(category.name),
    });
  });
  return convertedCategories;
};
